import React from 'react'
import { styled, SxProps } from '@mui/material/styles'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkToc from 'remark-toc'
import { githubStyle } from './style'
export interface MarkDownProps {
  title?: string;
  content?: string;
  sx?: SxProps;
}

const MarkDownComponent = styled('div')`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-top: 2px;
  line-height: 22px;
  & {
    ${githubStyle}
  }
`

const MarkDown: React.FC<MarkDownProps> = (props) => {
  const { content = '', sx } = props
  return (
    <MarkDownComponent sx={sx}>
      {/* <Typography variant="h6">{title}</Typography> */}
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkToc]}>
        {content}
      </ReactMarkdown>
    </MarkDownComponent>
  )
}

export default MarkDown
